/* eslint-disable no-extend-native */
export abstract class DateHelpers {
  static Max = (date1: Date, date2: Date) => {
    return new Date(Math.max(date1.getTime(), date2.getTime()));
  };

  static Min = (date1: Date, date2: Date) => {
    return new Date(Math.min(date1.getTime(), date2.getTime()));
  };
}

declare global {
  interface Date {
    StartOfDay: () => Date;
    EndOfDay: () => Date;
    GetCurrentTime: () => Date;
    DaysDiff: (date: Date) => number;
    toStringForInput: () => string
    toStringForInputWithTime: () => string
    toStringForPreview: () => string
    toStringForPreviewWithTime: () => string
  }
}

Object.defineProperty(Date.prototype, 'StartOfDay', {
  enumerable: false,
  configurable: true,
  writable: true,
  value() {
    const result = new Date(this);
    result.setHours(0, 0, 0, 0);
    return result;
  },
});

Object.defineProperty(Date.prototype, 'EndOfDay', {
  enumerable: false,
  configurable: true,
  writable: true,
  value() {
    const result = new Date(this);
    result.setHours(23);
    result.setMinutes(59);
    result.setSeconds(59);
    return result;
  },
});

Object.defineProperty(Date.prototype, 'GetCurrentTime', {
  enumerable: false,
  configurable: true,
  writable: true,
  value() {
    const result = new Date(this);
    const date = new Date();
    result.setHours(date.getHours(), date.getMinutes(), date.getSeconds());
    return result;
  },
});

Object.defineProperty(Date.prototype, 'DaysDiff', {
  enumerable: false,
  configurable: true,
  writable: true,
  value(date: Date) {
    const difference = Math.abs(this.StartOfDay().getTime() - date.StartOfDay().getTime());
    return Math.ceil(difference / (1000 * 3600 * 24));
  },
});

Object.defineProperty(Date.prototype, 'toStringForInput', {
  enumerable: false,
  configurable: true,
  writable: true,
  value() {
    return `${this.getFullYear().toString()}-${(`0${this.getMonth() + 1}`).slice(-2)}-${(`0${this.getDate()}`).slice(-2)}`;
  },
});

Object.defineProperty(Date.prototype, 'toStringForInputWithTime', {
  enumerable: false,
  configurable: true,
  writable: true,
  value() {
    return `${this.getFullYear().toString()}-${(`0${this.getMonth() + 1}`).slice(-2)}-${(`0${this.getDate()}`).slice(-2)}T${this.toTimeString().slice(0, 5)}`;
  },
});

Object.defineProperty(Date.prototype, 'toStringForPreview', {
  enumerable: false,
  configurable: true,
  writable: true,
  value() {
    return `${(`0${this.getDate()}`).slice(-2)}.${(`0${this.getMonth() + 1}`).slice(-2)}.${this.getFullYear().toString()}`;
  },
});

Object.defineProperty(Date.prototype, 'toStringForPreviewWithTime', {
  enumerable: false,
  configurable: true,
  writable: true,
  value() {
    return `${(`0${this.getDate()}`).slice(-2)}.${(`0${this.getMonth() + 1}`).slice(-2)}.${this.getFullYear().toString()} ${this.toTimeString().slice(0, 5)}`;
  },
});
